import { useSelector } from 'react-redux';

import classNames from 'classnames';

import { remoteConfigSelector } from '@web-solutions/core/store/remote-config/selectors';

import { t } from "@web-solutions/module-localization";
//@ts-ignore
import classes from "@web-solutions/core/ui-elements/button/style.module.scss";

import { Button } from "@web-solutions/core/ui-elements";

import { useAppSelector } from '@web-solutions/store/types';

import CardElement from '../card-element';
import { PaymentSystem } from '../../constants';
import { getPaymentSystem } from '../../utils/storage';

import { useCardFormMethods } from '../../hooks/use-card-form-methods';

//@ts-ignore
import styles from './styles.module.css';
const CardForm = (props) => {

  const {
    paymentSystem = getPaymentSystem(),
    product,
    onReady,
    onApplePayClick,
    onGooglePayClick,
    onUserInfoChange,
    onEvent,
    formClassName,
    buttonClassName,
    fieldClassName,
    buttonTitle,
    buttonConfig,
    additionalFields = {},
    options = {},
    inputStyles,
    labelStyles,
    notEmptyLabelStyles,
    children,
    subscriptionPageType
  } = props

  const { paymentPopup } = useSelector(remoteConfigSelector)

  const isPending = useAppSelector((state) => state.billing.pending || state.billing.orderPending);

  const {
    handleSubmit,
    formRef,
    isInvalidCardForm,
    submitted,
    submitButtonStyle,
    handleSuccess,
    handleError,
    handleCardElementChange,
    handleApplePaySubmit,
    handleGooglePaySubmit,
    renderFields
  } = useCardFormMethods({
    ...props,
    additionalFields,
    options,
    paymentSystem,
    styles
  })

  if (paymentSystem === PaymentSystem.SOLIDGATE) {
    options.formParams = options.formParams || {};
    options.formParams.submitButtonText = t(buttonTitle);
    options.formParams.submitButtonStyle = submitButtonStyle;
    options.formParams.merchantDataRefresh = true;
    if (additionalFields?.cardholder) {
      options.formParams.isCardHolderVisible = true;
    }
    if (additionalFields?.zip) {
      options.formParams.allowedAdditionalFields = ['ZIP'];
      delete additionalFields?.zip;
    }
  }

  const fromClassNames = classNames(styles.form, formClassName);

  const cardClassNames = classNames(
    styles.field,
    { [styles.invalid]: isInvalidCardForm },
    { [styles.submitted]: submitted },
    fieldClassName
  );

  const buttonClassNames = classNames(
    styles.button,
    buttonClassName
  );
  
  return (
    <form onSubmit={handleSubmit} className={fromClassNames} ref={formRef}>
      <CardElement
      //@ts-ignore
        paymentSystem={paymentSystem}
        product={product}
        options={options}
        className={cardClassNames}
        onSubmit={handleSubmit}
        onChange={handleCardElementChange}
        onReady={onReady}
        onSuccess={handleSuccess}
        onError={handleError}
        onApplePayClick={onApplePayClick}
        onApplePaySubmit={handleApplePaySubmit}
        onGooglePayClick={onGooglePayClick}
        onGooglePaySubmit={handleGooglePaySubmit}
        onUserInfoChange={onUserInfoChange}
        onEvent={onEvent}
        inputStyles={inputStyles}
        labelStyles={labelStyles}
        notEmptyLabelStyles={notEmptyLabelStyles}
        paymentPopup={paymentPopup}
        subscriptionPageType={subscriptionPageType}
        buttonTitle={buttonTitle}
      />

      {renderFields()}

      {children}

      {paymentSystem !== PaymentSystem.PADDLE && paymentSystem !== PaymentSystem.SOLIDGATE && paymentSystem !== PaymentSystem.TRUEGATE && (
        <Button 
          type='submit' 
          disabled={isPending} 
          className={buttonClassNames} 
          title={<>
            {buttonConfig.iconTitle && <img className={styles.iconIconTitle} src={buttonConfig.iconTitle} alt="icon title" />}
            <span>{t(buttonTitle)}</span>
            {buttonConfig.arrowIcon && <img className={classes['button__custom-right-icon']} src={buttonConfig.arrowIcon} alt="arrow" />}
            </>
          } />
      )}
    </form>
  );
};

export default CardForm;
